import { Pressable, VStack } from 'native-base';
import Icon from 'ui/components/Icon';

export type HelpButtonProps = {
  onPress?: VoidFunction;
  size?: string | number;
  padding?: string | number;
};

export const HelpButton = ({
  onPress,
  size = 4,
  padding = 2,
}: HelpButtonProps) => {
  return (
    <VStack p={padding} h="fit-content">
      <Pressable onPress={onPress}>
        <Icon
          icon="question"
          color={'primary.400'}
          size={size}
          enableAutoCustom
        />
      </Pressable>
    </VStack>
  );
};
